export const GALLERY_MODE = {
  NORMAL:'normal',
  SELECT_MULTIPLE:'select_multiple',
}